// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from "vue-i18n"
import locale from 'element-ui/lib/locale'
import App from './src/App'
import router from './src/router/index.js'
import clipboard from 'clipboard';
import './static/js/lib/directive.js'
import './static/js/lib/ie9placeholder.js'
import ElementUI from "element-ui"
import message from "./static/js/lib/resetMessage.js"
import store from "store"
import "./static/less/index.less"
import "element-ui/lib/theme-chalk/index.css"
import "./static/less/element-reset.less"
import 'babel-polyfill'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.prototype.$message = message;
Vue.prototype.clipboard = clipboard;//复制粘贴功能

//全局修改tooltip组件,自定义的依然有效
ElementUI.Tooltip.props.transition.default = '';
ElementUI.Tooltip.props.openDelay.default = 300;

//全局store
store.dispatch("getLanguage"); //获取当前语言
// store.dispatch("getUserInfo"); //获取当前用户信息
// store.dispatch("getAccountInfo"); //获取当前账号信息
// store.dispatch("getCustomizeInfo"); //获取当前自定义信息
// store.dispatch("getSession").then((data) => {
//     if (data.accountManageMode && data.accountManageMode === "enterprise") { //是否是企业版
//         Vue.prototype.ENTERPRISE = true;
//     } else {
//         Vue.prototype.ENTERPRISE = false;
//     }
// }); //获取session
// store.dispatch("getUserRole"); //获取用户角色
//多语言
const i18n = new VueI18n({
    locale: store.state.lenovoData.language || "zh", // 语言标识
    messages: {
        zh: require("./static/js/language/zh.js"), //中文
        en: require("./static/js/language/en.js"), //英文
        tw: require("./static/js/language/tw.js"), //繁体
        ja: require("./static/js/language/ja.js") //日文
    }
});
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

router.beforeEach((to, from, next) => {
    let toPath = to.fullPath;
    let reg = /^\/api\/*/;
    if (reg.test(toPath)) {
        let goback = localStorage.getItem('goback');
        if (goback) {
            localStorage.removeItem('goback');
            localStorage.setItem('currentMenu', '/api/ProductGuide');
            next({path: '/api/ProductGuide'});
        } else {
            localStorage.setItem('currentMenu', toPath);
        }
    } else {
        localStorage.removeItem('currentMenu');
    }
    next();
})

new Vue({
    el: '#edas',
    router,
    store,
    i18n,
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./main.js